import { Component, Input, SimpleChange } from '@angular/core';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-line-chart-html',
  templateUrl: './line-chart-html.component.html',
  styleUrls: ['./line-chart-html.component.scss']
})
export class LineChartHtmlComponent {
  @Input() barData:any[]=[];
  @Input() groups:any;
  @Input() titlechart:string='';
  @Input() maxValue:number=280;
  @Input() barwidth:number=24;
  @Input() duration:number=1000;
  yAxis =  Array.from({length: 7}, (_, i) => i+1)
  height=257;

  constructor(
    public autoMl:AutoMlService
  ){}

  ngOnInit(){
  }

  ngOnChanges(sample:SimpleChange){
    // console.log(sample);
  }

  rangeArr(item:number){
    return Math.round(item*(this.maxValue/7)) ;
  }

  getSeparatr(data:any){
   return data.toLocaleString("en-US");
  }


}
